var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-lg": "" } },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-slide-y-transition",
                { attrs: { mode: "out-in" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "primary white--text pa-4",
                          attrs: { dark: "" }
                        },
                        [
                          _vm.createButton
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "accent",
                                    dark: "",
                                    disabled: _vm.freeze
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.triggerCreateEvent($event)
                                    }
                                  }
                                },
                                [
                                  _vm.createButtonText
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.createButtonText) +
                                            "\n                                "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                                    New " +
                                            _vm._s(
                                              _vm.ucFirst(_vm.singleItemName)
                                            ) +
                                            "\n                                "
                                        )
                                      ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text--white text-uppercase subtitle-1 font-weight-medium px-3"
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.totalItems) +
                                  "\n                                "
                              ),
                              _vm.totalItems === 1
                                ? _c("span", [_vm._v("Result")])
                                : _c("span", [_vm._v("Results")])
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "searching",
                              class: { "searching--closed": !_vm.searching }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  id: this.singleItemName + "-search",
                                  "append-icon": "$mdiClose",
                                  placeholder: "Search",
                                  "hide-details": "",
                                  autocomplete: "new-password",
                                  solo: "",
                                  disabled: _vm.freeze
                                },
                                on: { "click:append": _vm.searchEnd },
                                model: {
                                  value: _vm.searchQuery,
                                  callback: function($$v) {
                                    _vm.searchQuery = $$v
                                  },
                                  expression: "searchQuery"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.searchButton
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    dark: "",
                                    disabled: _vm.freeze
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.searchBegin($event)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("$mdiMagnify")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filterButton && _vm.selectedFiltersCount > 0
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    dark: "",
                                    disabled: _vm.freeze
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.resetFilters($event)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v("$mdiFilterRemoveOutline")
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filterButton
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    dark: "",
                                    disabled: _vm.freeze
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleFilterDrawer($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-badge",
                                    {
                                      attrs: {
                                        value: _vm.selectedFiltersCount !== 0,
                                        color: "error",
                                        left: "",
                                        overlap: ""
                                      }
                                    },
                                    [
                                      _vm.selectedFiltersCount !== 0
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "badge" },
                                              slot: "badge"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.selectedFiltersCount
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("v-icon", [
                                        _vm._v("$mdiFilterVariant")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("additional-buttons"),
                          _vm._v(" "),
                          _vm.refreshButton
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    dark: "",
                                    disabled: _vm.freeze
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.fetchData($event)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("$mdiAutorenew")])],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-1 alternative bg-alternative",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.items,
                          options: _vm.options,
                          "server-items-length": _vm.totalItems,
                          loading: _vm.fetching,
                          "footer-props": {
                            "items-per-page-options":
                              _vm.$store.getters["application/getPerPage"],
                            "disable-items-per-page": _vm.freeze,
                            "disable-pagination": _vm.freeze
                          },
                          "multi-sort": "",
                          "disable-filtering": _vm.freeze,
                          "disable-pagination": _vm.freeze,
                          "disable-sort": _vm.freeze,
                          "mobile-breakpoint": _vm.breakpoint,
                          dark: ""
                        },
                        on: {
                          "update:options": function($event) {
                            _vm.options = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function(ref) {
                                var items = ref.items
                                var isMobile = ref.isMobile
                                return [
                                  _c(
                                    "tbody",
                                    _vm._l(items, function(item, index) {
                                      return _c(
                                        "tr",
                                        {
                                          key: index,
                                          class: [
                                            isMobile
                                              ? "v-data-table__mobile-table-row"
                                              : "",
                                            _vm.clickable ? "pointer" : ""
                                          ],
                                          on: {
                                            click: function($event) {
                                              return _vm.triggerClickEvent(item)
                                            }
                                          }
                                        },
                                        [
                                          isMobile
                                            ? [
                                                _vm._t(
                                                  "card",
                                                  _vm._l(_vm.headers, function(
                                                    header,
                                                    headerIndex
                                                  ) {
                                                    return _c(
                                                      "td",
                                                      {
                                                        key: headerIndex,
                                                        staticClass:
                                                          "v-data-table__mobile-row"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "v-data-table__mobile-row__header"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  header.text
                                                                ) +
                                                                "\n                                                    "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "v-data-table__mobile-row__cell"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.getCardValue(
                                                                    item,
                                                                    header.value
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  { item: item }
                                                )
                                              ]
                                            : [
                                                _vm._t("row", null, {
                                                  item: item
                                                })
                                              ]
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }